<template>
	<el-footer class="footer-page dis-fle ali-cen">
		<div class="center-wrap">
			<div class="top-div dis-fle jus-bet bor-bot">
				<div class="left">
					<div class="logo-box">
						<img alt="Logo" class="logo" :src="logoImg">
					</div>
					<langModel trigger="click" placement="top">
						<div class="language-btn dis-fle ali-cen cur-poi">
							<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
								class="svg-class">
								<g id="Frame" clip-path="url(#clip0_17736_13116)">
									<path id="Vector"
										d="M8 0C12.4182 0 16 3.58182 16 8C16 12.4182 12.4182 16 8 16C3.58182 16 0 12.4182 0 8C0 3.58182 3.58182 0 8 0ZM8 1.45455C7.14044 1.45455 6.28929 1.62385 5.49516 1.95279C4.70103 2.28173 3.97947 2.76386 3.37166 3.37166C2.76386 3.97947 2.28173 4.70103 1.95279 5.49516C1.62385 6.28929 1.45455 7.14044 1.45455 8C1.45455 8.85956 1.62385 9.71071 1.95279 10.5048C2.28173 11.299 2.76386 12.0205 3.37166 12.6283C3.97947 13.2361 4.70103 13.7183 5.49516 14.0472C6.28929 14.3762 7.14044 14.5455 8 14.5455C9.73596 14.5455 11.4008 13.8558 12.6283 12.6283C13.8558 11.4008 14.5455 9.73596 14.5455 8C14.5455 6.26404 13.8558 4.59918 12.6283 3.37166C11.4008 2.14415 9.73596 1.45455 8 1.45455Z">
									</path>
									<path id="Vector_2"
										d="M8.00001 0C10.424 2.38764 11.6364 5.05455 11.6364 8C11.6364 10.9455 10.424 13.6124 8.00001 16C5.57601 13.6124 4.36365 10.9455 4.36365 8C4.36365 5.05455 5.57601 2.38764 8.00001 0ZM8.00001 2.15564L7.82401 2.37818C6.47565 4.12291 5.81819 5.98546 5.81819 8C5.81819 10.0145 6.47565 11.8771 7.82401 13.6218L8.00001 13.8436L8.17601 13.6218C9.46547 11.9527 10.1236 10.1753 10.1782 8.26182L10.1818 8C10.1818 5.98618 9.52437 4.12291 8.17601 2.37818L8.00001 2.15564Z">
									</path>
									<path id="Vector_3" d="M0.727295 7.27246H15.2728V8.72701H0.727295V7.27246Z">
									</path>
								</g>
								<defs>
									<clipPath id="clip0_17736_13116">
										<rect width="16" height="16"></rect>
									</clipPath>
								</defs>
							</svg>
							<span class="">{{ langName }}</span>
							<i class="el-icon-caret-right"></i>
						</div>
					</langModel>
					<div class="ul-list dis-fle">
						<div class="bottom-item">
							<span class="title txt-20">{{ $t('交易市场') }}</span>
							<div class="dis-fle flex-col">
								<span class="txt-14" @click="$nav.go('/pc/trade')">{{ $t('期权') }}</span>
								<span class="txt-14" @click="$nav.go('/pc/spotGoods')">{{ $t('现货') }}</span>
								<span class="txt-14" @click="$nav.go('/pc/contract')">{{ $t('合约') }}</span>
								<!-- <span class="txt-14">{{ $t('期权') }}</span> -->
							</div>
						</div>
						<div class="bottom-item">
							<span class="title txt-20">{{ $t('资产管理') }}</span>
							<div class="dis-fle flex-col">
								<span class="txt-14" @click="$nav.go('/pc/assetsIndex')">{{ $t('我的资产') }}</span>
								<span class="txt-14" @click="$nav.go('/pc/deposit')">{{ $t('充币') }}</span>
								<span class="txt-14" @click="$nav.go('/pc/withdrawDeposit')">{{ $t('提现') }}</span>
								<span class="txt-14" @click="$nav.go('/pc/assetsIndex?key=8')">{{ $t('划转') }}</span>
								<!-- <span class="txt-14">{{ $t('订单中心') }}</span> -->
							</div>
						</div>
						<div class="bottom-item">
							<span class="title txt-20">{{ $t('产品') }}</span>
							<div class="dis-fle flex-col">
								<span class="txt-14" @click="$nav.go('/pc/invitation')">{{ $t('邀请有奖') }}</span>
								<!-- <span class="txt-14">{{ $t('金融理财') }}</span> -->
							</div>
						</div>
						<div class="bottom-item">
							<span class="title txt-20">{{ $t('支持') }}</span>
							<div class="dis-fle flex-col">
								<!-- <span class="txt-14">{{ $t('现货') }}</span> -->
								<span class="txt-14" @click="openKefu">{{ $t('在线客服') }}</span>
								<span class="txt-14" @click="$nav.go('/pc/article?type=4')">{{ $t('新手教程') }}</span>
								<span class="txt-14" @click="$nav.go('/pc/article?type=3')">{{ $t('关于我们') }}</span>
							</div>
						</div>
						<div class="bottom-item">
							<span class="title txt-20">{{ $t('政策') }}</span>
							<div class="dis-fle flex-col">
								<span class="txt-14" @click="$nav.go('/pc/article?type=6')">{{ $t('服务条款') }}</span>
								<span class="txt-14" @click="$nav.go('/pc/article?type=7')">{{ $t('隐私协议') }}</span>
								<span class="txt-14" @click="$nav.go('/pc/article?type=5')">{{ $t('反洗钱协议') }}</span>
							</div>
						</div>
					</div>
				</div>
				<div v-if="footText" class="row-list txt-14 txt-ali-rig" v-html="footText"></div>
				<div v-else class="row-list dis-fle txt-14 txt-ali-rig">
					<span class="row">{{ $t('版权所有@2024©️EXCHANGE一家专职虚拟货币的服务公司 致诚之职 服务至上') }}</span>
					<span class="row">{{ $t('客户服务：') }} <a>0123</a></span>
					<span class="row">{{ $t('商务合作：') }} <a>1+(469)2078685</a></span>
					<span class="row">VIP {{ $t('服务：') }} <a href="mailto:test@outlook.com"
							class="a-line">test@outlook.com</a></span>
					<div class="logo-list">
						<span class="Twitter">
							<img src="@/assets/img-pc/1.svg" />
						</span>
						<span class="Facebook">
							<img src="@/assets/img-pc/2.svg" />
						</span>
					</div>
				</div>
			</div>
			<div class="bottom-copyRight txt-14">
				<span class="">{{ $t('随时随地多平台终端交易。 多终端完美相容，随时满足各种场景的交易需求。') }}</span>
			</div>
		</div>
		<div class="tel-muan-foor cur-poi">
			<div class="dis-fle flex-col" @click="$nav.go('/pc/home')">
				<img src="@/assets/img-pc/3.svg" />
			</div>
			<div class="dis-fle flex-col" @click="$nav.go('/pc/quotes')">
				<img src="@/assets/img-pc/4.svg" />
			</div>
			<div class="dis-fle flex-col" @click="$nav.go('/pc/trade')">
				<img src="@/assets/img-pc/5.svg" />
			</div>
			<div class="dis-fle flex-col" @click="$nav.go('/pc/portfolio')">
				<img src="@/assets/img-pc/6.svg" />
			</div>
			<div class="dis-fle flex-col" @click="$nav.go('/pc/assetsIndex')">
				<img src="@/assets/img-pc/7.svg" />
			</div>
		</div>
	</el-footer>
</template>


<script>
import { mapState, mapMutations } from "vuex";
import langModel from './Lang.vue'
import { openKefu } from '@/common/public.js';
export default {
	components: {
		langModel
	},

	data() {
		return {

		};
	},
	computed: {
		...mapState(["defaultLang", "langList", "config"]),
		langName() {
			let arr = this.langList || []
			let lang = this.defaultLang
			return arr.filter(item => item.value == lang)[0]?.name || ''
		},
		logoImg() {
			return this.config.logo || require('@/assets/img-pc/logo.png')
		},
		footText() {
			return this.config.foot_text?.content || ''
		}
	},
	watch: {

	},
	created() {


	},
	methods: {
		...mapMutations(["setDefaultLang",]),
		openKefu,
	},
};
</script>

<style lang="scss" scoped>
.footer-page {
	background-color: #0b0b0e;
	font-size: 14px;
	display: flex;
	align-items: center;
	min-height: 596px;
	padding: 60px 0;

	.tel-muan-foor {
		padding-right: 22px;
	}

	.top-div {
		padding-bottom: 40px;

		.ul-list {
			margin-top: 20px;
			font-size: 15px;
			font-weight: 500;
			min-height: 20px;
			line-height: 20px;

			.bottom-item {
				min-width: 116px;
				margin-right: 10px;

				.title {
					display: inline-block;
					line-height: 26px;
					margin-bottom: 16px;
				}

				.txt-14 {
					cursor: pointer;
					margin-bottom: 14px;

					&:hover {
						color: #fff;
					}
				}
			}
		}
	}

	.bottom-copyRight {
		padding: 30px 0px;
	}

	.txt-14 {
		color: #888;
	}

	.left {
		.logo-box {
			.logo {
				height: 33px;
				width: auto;
			}
		}

		.language-btn {
			width: 160px;
			height: 46px;
			border-radius: 99px;
			color: #fff;
			border: 1px solid #2c2c3e;
			margin-top: 30px;
			background: #0b0b0e;
			position: relative;
			// display: flex;
			// align-items: center;
			justify-content: space-around;
			cursor: pointer;
		}
	}

	.row-list {
		width: 530px;
		flex-direction: column;

		.row {
			line-height: 20px;

			&:first-of-type {
				margin-bottom: 20px;
			}
		}

		.logo-list {
			margin-top: 35px;

			img {
				width: 36px;
				height: 36px;
				margin-left: 14px;
				cursor: pointer;
			}
		}
	}
}
</style>